import { getSession } from '@pwa/lib/auth-client';
import { queryOptions } from '@tanstack/react-query';

export const sessionQueryOptions = queryOptions({
	queryKey: ['session'],
	queryFn: async () => getSession(),
	staleTime: 1000 * 60 * 5, // 5 minutes
});
